import type { HistoryCommonConfig, HistoryDeleteModalTheme } from './types'
import { novelmelloDeleteTheme } from './novelmello'
import { loadBrandConfig } from '@/utils/loadBrandConfig'
import { t } from '@/i18n/utils'

export type { HistoryCommonConfig, HistoryDeleteModalTheme } from './types'

/**
 * 删除弹窗按钮主题
 * - confirm 按钮统一使用品牌主色 `n-primary`（UnoCSS），白字
 * - cancel 按钮在浅色/深色品牌之间差异较大，按品牌单独配置
 */
const lightDeleteTheme: HistoryDeleteModalTheme = {
  modalBg: '#FFFFFF',
  cancelBg: 'rgba(243, 245, 250, 1)',
  cancelColor: 'rgba(101, 104, 111, 1)',
}

const darkDeleteTheme: HistoryDeleteModalTheme = {
  modalBg: '#1F1E20',
  cancelBg: '#363537',
  cancelColor: '#F4F4F4',
}

export const historyDeleteModalTheme = loadBrandConfig<HistoryDeleteModalTheme>({
  rocnovel: lightDeleteTheme,
  oceread: lightDeleteTheme,
  ficmoon: darkDeleteTheme,
  novelarc: lightDeleteTheme,
  storyella: lightDeleteTheme,
  aurenovel: lightDeleteTheme,
  silktale: lightDeleteTheme,
  pearla: lightDeleteTheme,
  fictora: darkDeleteTheme,
  marinovel: lightDeleteTheme,
  talewave: lightDeleteTheme,
  flipnovel: darkDeleteTheme,
  moonpage: lightDeleteTheme,
  storlyn: lightDeleteTheme,
  novaris: darkDeleteTheme,
  novelune: lightDeleteTheme,
  novelmello: novelmelloDeleteTheme,
})

/**
 * 历史记录页面通用文案
 */
export const historyCommonConfig: HistoryCommonConfig = {
  texts: {
    get noData() { return t('NoData') },
    get goToNovel() { return t('GoToNovel') },
    get viewed() { return t('ViewedTab') },
    get completed() { return t('Completed') },
    get ongoing() { return t('OnGoing') },
    get lastRead() { return t('LastRead') },
    // 与 en.json 不完全匹配（逗号前有空格差异）
    get noMore() { return t('noMore') },
    get loading() { return `${t('Loading')}...` },
    get bookRemoved() { return t('BookRemoved') },
  },
}
